import { render, staticRenderFns } from "./ProductionPlaceGuide.vue?vue&type=template&id=08bbd160"
import script from "./ProductionPlaceGuide.vue?vue&type=script&lang=js"
export * from "./ProductionPlaceGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports